{ flatten, join, keys, map, Obj } = require 'prelude-ls'

# accepts arbitary arguments of string or object of {<key>: <boolean>}
export css-classes = ->
  arguments
    |> map (arg) ->
        | (typeof arg) is 'object' =>
            arg |> Obj.compact |> keys
        | otherwise => arg
    |> flatten
    |> join ' '



// WEBPACK FOOTER //
// src/index.ls